export default timetableService => {
    return function (input, key, filters) {
        var val = filters[key],
            isOnline,
            c, // the class item for the inner loop
            item; // the course item for the outer loop

        for (var i = 0, l = input.length; i < l; i++) {
            item = input[i];

            for (var j = 0, m = item.classes.length; j < m; j++) {
                c = item.classes[j];
                isOnline = c.room.startsWith('ONL') || c.classType.startsWith('ONL');
                if (val === 'Show all' ||
                    val.startsWith('On-campus') && !isOnline ||
                    val.startsWith('Online') && isOnline) {
                    c[key + 'Filter'] = true;
                } else {
                    c[key + 'Filter'] = false;
                }
            }

            input[i] = timetableService.checkForVisibleChildren(item, filters);
        }

        return input;
    }
};